import { PlantRoleRequest, stockDropdownData, UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse, ItemCategoriesDropDownResponseModel, ItemRequest, ItemsDropDownResponseModel, ItemSubCategoriesDropDownResponse, SizesDropDownResponseModel } from '@gtpl/shared-models/masters';
import { AvailableStockQtyResponseModel, StocktemRequest, AllStockResponseModel, StockInputRequest, StockQtyResponseModel, SaleOrderIdRequest, ItemCategoryIdReq, CategorySubCategoryReq, QtyRequest, GetAvailableStockResponse, SizeIdRequest, StockDto, SoPackingStatusDto, ProductConversionModel, PlantItemSubCategoryIdReq, PackingBomRequest, CycleCheckerDto } from '@gtpl/shared-models/procurement-management';
import { BomItemRemovedQty, SaleOrderDropDownResponseModel, SaleOrderFewDetailsResponseModel, SoPackingStatusRequest } from '@gtpl/shared-models/sale-management';
import axios from 'axios';
import connection from './connection';
// import { PoDropDownDto, PoDropDownResponseModel } from "@gtpl/shared-models/procurement-management";


export class StockService {
    URL = connection.DEPLOY_URL + '/stock';

    async getAvailableStockQty(stockItemRequest: StocktemRequest): Promise<AvailableStockQtyResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockQty', stockItemRequest)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }


    async getInventoryStockQty(stockItemRequest: StocktemRequest): Promise<AvailableStockQtyResponseModel> {
        console.log(stockItemRequest);
        return await axios.post(this.URL + '/getInventoryStockQty', stockItemRequest)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getAllStockData(plantroleReq?:PlantRoleRequest): Promise<AllStockResponseModel> {
        return await axios.post(this.URL + '/getAllStockData',plantroleReq)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async AssignInventoryStock(stockReq: StockInputRequest): Promise<boolean> {
        return await axios.post(this.URL + '/AssignInventoryStock', stockReq)
            .then(res => {
                return res
            }).catch(error => {
                return error;
            })
    }

    async AssignDummyPackingInventoryStock(stockReq: StockInputRequest): Promise<boolean> {
        return await axios.post(this.URL + '/AssignDummyPackingInventoryStock', stockReq)
            .then(res => {
                return res
            }).catch(error => {
                return error;
            })
    }

    

    async updateRemovedAssignedQtyForSo(stockReq: BomItemRemovedQty): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateRemovedAssignedQtyForSo', stockReq)
            .then(res => {
                return res
            }).catch(error => {
                return error;
            })
    }

    async getAvailableStockSosForConsumption(req?: UnitRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockSosForConsumption', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getAvailableStockSosForReturns(): Promise<SaleOrderFewDetailsResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockSosForReturns')
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }
    async getAvailableStockForSO(saleOrderReq: SaleOrderIdRequest): Promise<StockQtyResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockForSO', saleOrderReq)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getAvailableStockItemCategories(req: UnitRequest): Promise<ItemCategoriesDropDownResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockItemCategories', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getAvailableStockItemSubCategories(req: ItemCategoryIdReq): Promise<ItemSubCategoriesDropDownResponse> {
        return await axios.post(this.URL + '/getAvailableStockItemSubCategories', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }
    
    async getAvailableStockItems(req: CategorySubCategoryReq): Promise<ItemsDropDownResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockItems', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getAvailableStockTransferItems(req: CategorySubCategoryReq): Promise<ItemsDropDownResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockTransferItems', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getAvailableStockSizes(req: SizeIdRequest): Promise<SizesDropDownResponseModel> {
        return await axios.post(this.URL + '/getAvailableStockSizes', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }


    async getAvailableTransferStockQty(req: QtyRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAvailableTransferStockQty', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }


    async getAvailableStockSoItems(saleOrderReq: SaleOrderIdRequest): Promise<GetAvailableStockResponse> {
        return await axios.post(this.URL + '/getAvailableStockSoItems', saleOrderReq)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async stockEntry(dto: StockDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/stockEntry', dto)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async stockEdit(dto: StockDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/stockEdit', dto)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async stockConversion(dto: ProductConversionModel): Promise<CommonResponse> {
        return await axios.post(this.URL + '/stockConversion', dto)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }

    async getStockDetailsForItemId(req: ItemRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getStockDetailsForItemId', req)
            .then(res => {
                return res.data
            }).catch(error => {
                return error;
            })
    }
   
    async getSoPackingStatus(req:SoPackingStatusRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSoPackingStatus', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async moveLeftOverQtyIntoBulk(req:SaleOrderIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/moveLeftOverQtyIntoBulk', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    

    async getavailbleItemsInStock(req:SaleOrderIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getavailbleItemsInStock', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async cancelledSoStockUpdate(req:SaleOrderIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/cancelledSoStockUpdate', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    

    async getPhysicalQuantityForItemId(req:ItemRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPhysicalQuantityForItemId', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async getStockAvailSos(req:PlantItemSubCategoryIdReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getStockAvailSos', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async getAllStockDataForReport(req:stockDropdownData) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllStockDataForReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async getPoNumberForProductConversion(req:PlantItemSubCategoryIdReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPoNumberForProductConversion', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async getPackingItemsForSoId(req:SaleOrderIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPackingItemsForSoId', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async getTransferredSosDataForStockGrid( req?: UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTransferredSosDataForStockGrid', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getUnitDropdownForStockInReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getUnitDropdownForStockInReport')
            .then(res => {
                return res.data
            })
    }
    async getPackingBomReport (req?:PackingBomRequest): Promise <CommonResponse>{
        return await axios.post(this.URL + '/getPackingBomReport',req)
          .then(res =>{
              return res.data
          })
    }
    async getSoDropForBomReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSoDropForBomReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getSoDropForStockReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSoDropForStockReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getItemSubDropForStockReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getItemSubDropForStockReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getItemDropForStockReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getItemDropForStockReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }
    async getBrandDropForStockReport(req:UnitRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getBrandDropForStockReport', req)
        .then(res => {
            return res.data
        }).catch(error=>{
            return error;
        })
    }

    async saveCycleCheckerEntry (req:CycleCheckerDto): Promise <CommonResponse>{
        return await axios.post(this.URL + '/saveCycleCheckerEntry',req)
          .then(res =>{
              return res.data
          })
    }

    async updateStockToBulk (req:SaleOrderIdRequest): Promise <CommonResponse>{
        console.log('--cshared-service')
        return await axios.post(this.URL + '/updateStockToBulk',req)
          .then(res =>{
              return res.data
          })
    }


}

